import { withOptionalFilters } from "./optionalFilters";
import { tenantKeys } from "./tenants";

export const teamAssignmentKeys = {
  base: (tenantId: string) =>
    [...tenantKeys.detail(tenantId), "teamAssignments", "v2"] as const,
  list: (
    tenantId: string,
    filters?: { startDate?: string; endDate?: string },
  ) =>
    withOptionalFilters(
      [...teamAssignmentKeys.base(tenantId), "list"] as const,
      filters,
    ),
  me: (tenantId: string) =>
    [...teamAssignmentKeys.base(tenantId), "me"] as const,
  detail: (tenantId: string, id: string) =>
    [...teamAssignmentKeys.base(tenantId), "detail", id] as const,
};
